/**
 * Plakietka przypisanego pracownika na liście zamówień (2026-10-08, właściciel, #119452: „na liście zamówień powinno
 * ładnie wyróżnić, że ktoś jest przypisany do tego”). Dane: `order.zlecenia` z GET /api/orders/unified — otwarte
 * zlecenia „Przypisz pracownika” (routers/orders_unified_listing._dolacz_zlecenia), najbliższy termin pierwszy.
 * Moduł bez importów (testowalny w node).
 */

function _esc(s: unknown): string {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function _czesciPL(d: Date): { dzien: string; godz: string } {
  const f = (o: Intl.DateTimeFormatOptions) => d.toLocaleString('pl-PL', Object.assign({ timeZone: 'Europe/Warsaw' }, o));
  return { dzien: f({ day: '2-digit', month: '2-digit' }), godz: f({ hour: '2-digit', minute: '2-digit' }) };
}

/** „15:00” gdy termin jest dziś (czas polski), inaczej „09.10 15:00”; '' bez terminu. */
export function terminKrotko(iso: string, teraz: Date = new Date()): string {
  const t = new Date(String(iso || ''));
  if (!iso || !isFinite(t.getTime())) return '';
  const a = _czesciPL(t);
  return a.dzien === _czesciPL(teraz).dzien ? a.godz : a.dzien + ' ' + a.godz;
}

export function poTerminie(iso: string, teraz: Date = new Date()): boolean {
  const t = new Date(String(iso || '')).getTime();
  return !!iso && isFinite(t) && t < teraz.getTime();
}

/** Plakietka „👤 Bartek M · do 15:00” (+N gdy więcej zleceń); czerwona po terminie. Pusta bez zleceń. */
export function chipZlecenHtml(zlecenia: any[], teraz: Date = new Date()): string {
  const lista = Array.isArray(zlecenia) ? zlecenia.filter((z) => z && (z.status === 'nowe' || z.status === 'w_toku')) : [];
  if (!lista.length) return '';
  const pierwsze = lista[0];
  const termin = terminKrotko(pierwsze.termin, teraz);
  const spoznione = lista.some((z) => poTerminie(z.termin, teraz));
  const kolor = spoznione ? 'var(--color-error)' : 'var(--color-primary)';
  const osoby = Array.from(new Set(lista.map((z) => String(z.kto || '—'))));
  const tytul = lista.map((z) => {
    const t = terminKrotko(z.termin, teraz);
    return 'Przypisany: ' + (z.kto || '—') + (z.od ? ' (zlecił ' + z.od + ')' : '')
      + (t ? ' · termin ' + t + (poTerminie(z.termin, teraz) ? ' — PO TERMINIE' : '') : '')
      + (z.opis ? '\n' + z.opis : '');
  }).join('\n\n');
  return '<span class="order-card-tags"><span class="ptag" data-zlecenia-chip="1" title="' + _esc(tytul) + '" style="border-color:' + kolor
    + ';color:' + kolor + ';font-weight:700;max-width:none">👤 ' + _esc(osoby[0])
    + (osoby.length > 1 ? ' +' + (osoby.length - 1) : '')
    + (termin ? ' · ' + (spoznione ? 'po terminie ' : 'do ') + _esc(termin) : '')
    + (lista.length > 1 && osoby.length === 1 ? ' · ' + lista.length + ' zlecenia' : '')
    + '</span></span>';
}
